import { useMemo } from 'react';

type StructuredDataScriptProps = {
  data?: unknown;
};

const stringify = (value: unknown): string | null => {
  try {
    return JSON.stringify(value);
  } catch (error) {
    console.warn('[StructuredDataScript] failed to stringify structured data', error);
    return null;
  }
};

export function StructuredDataScript({ data }: StructuredDataScriptProps) {
  if (data == null) {
    return null;
  }

  const json = useMemo(() => stringify(data), [data]);

  if (!json) {
    return null;
  }

  return (
    <script
      type="application/ld+json"
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
}
